var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import * as ServiceCollaborateur from '../../services/collaborateur';
import { EditionCollaborateur } from './EditionCollaborateur';
import { Table } from '../../utils/Table';
import { Link } from '../../utils/Link';
import { CollaborateurIcon } from '../../utils/Icons';
import { getOriginalUser } from '../../services/utilisateur';
var originalUser = getOriginalUser();
export var Collaborateur = function () {
    var _a = useState([]), collaborateurs = _a[0], setCollaborateurs = _a[1];
    var _b = useState(0), total = _b[0], setTotal = _b[1];
    var getData = function (_a) {
        var _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.itemByPage, itemByPage = _c === void 0 ? 10 : _c, _d = _a.filtres, filtres = _d === void 0 ? null : _d, _e = _a.order, order = _e === void 0 ? null : _e;
        return __awaiter(void 0, void 0, void 0, function () {
            var _f, Collaborateurs, Total, error_1;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ServiceCollaborateur.getCollaborateurListe({
                                page: page,
                                itemByPage: itemByPage,
                                filtres: filtres,
                                order: order,
                            })];
                    case 1:
                        _f = _g.sent(), Collaborateurs = _f.Collaborateurs, Total = _f.Total;
                        setCollaborateurs(Collaborateurs);
                        setTotal(Total);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _g.sent();
                        setCollaborateurs([]);
                        setTotal(0);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /*const handleSearchCollaborateur = (e: any) => {
      let value = e.target.value.toUpperCase()
      this.setState({ search: value })
    }
  
    const filteredCollaborateurs = () => {
      const search: string = this.state.search.toUpperCase()
      return this.state.Collaborateurs.filter((c) => {
        if (search.length == 0) {
          return true
        } else {
          return (
            (c.collaborateur_type &&
              c.collaborateur_type.Libelle &&
              c.collaborateur_type.Libelle.toUpperCase().includes(search)) ||
            (c.Nom && c.Nom.toUpperCase().includes(search)) ||
            (c.Prenom && c.Prenom.toUpperCase().includes(search)) ||
            (c.Email && c.Email.toUpperCase().includes(search)) ||
            (c.Telephone && c.Telephone.toUpperCase().includes(search)) ||
            (c.Mobile && c.Mobile.toUpperCase().includes(search)) ||
            (c.Pays && c.Pays.toUpperCase().includes(search)) ||
            (c.Ville && c.Ville.toUpperCase().includes(search)) ||
            (c.CodePostal && c.CodePostal.toUpperCase().includes(search)) ||
            (c.Adresse && c.Adresse.toUpperCase().includes(search)) ||
            (c.Longitude && c.Longitude.toUpperCase().includes(search)) ||
            (c.Latitude && c.Latitude.toUpperCase().includes(search)) ||
            (c.Commentaire && c.Commentaire.toUpperCase().includes(search))
          )
        }
      })
    }*/
    //const Collaborateurs = this.filteredCollaborateurs()
    return (_jsx(_Fragment, { children: _jsx(Table, { title: 'Collaborateurs', color: "collaborateur", canEdit: originalUser.CanEditCollaborateur, renderModalEdition: function (handleClose) { return (_jsx(EditionCollaborateur, { CollaborateurId: null, onChange: function () { return handleClose(); } })); }, onExport: originalUser.CanExportCollaborateur
                ? function (filtres) { return ServiceCollaborateur.exportCollaborateur(filtres); }
                : null, typeFiltre: "Collaborateur", refresh: getData, total: total, isResponsive: true, headers: [
                {
                    label: 'Collaborateur',
                    component: function (value, _a) {
                        var color = _a.color;
                        return (_jsx(Link, { title: value.getLibelle, color: color, to: '/collaborateur/fiche/' + value.IdCollaborateur, className: "flex", icon: _jsx(CollaborateurIcon, {}), bold: true }));
                    },
                    orderBy: 'Nom,Prenom',
                },
                {
                    label: 'Type',
                    assessor: 'collaborateur_type.Libelle',
                    orderBy: 'CollaborateurTypeId',
                },
                { label: 'Ville', assessor: 'Ville', orderBy: 'Ville' },
                {
                    label: 'Code postal',
                    align: 'right',
                    assessor: 'CodePostal',
                    orderBy: 'CodePostal',
                },
                {
                    label: 'Adresse',
                    assessor: 'Adresse',
                    orderBy: 'Adresse',
                },
            ], datas: collaborateurs ? collaborateurs : [] }) }));
};
//# sourceMappingURL=Collaborateur.js.map